import { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { flowRight as compose } from 'lodash';

import JLoading from 'components/JLoading';
import * as E from './styles';

class ActiveParticipantChat extends Component {
  componentDidMount() {
    this.props.store.messengerStore.getDispatchers();
  }

  render() {
    const { messengerStore } = this.props.store;
    const { dispatchers, userListing, topicSelected } = messengerStore;
    const ActiveParticipants =
      (topicSelected &&
        ((topicSelected.protege_ids &&
          topicSelected.follower_ids &&
          topicSelected.protege_ids.length &&
          topicSelected.follower_ids.map((uid) => topicSelected.protege_ids.indexOf(uid) === -1 && uid).filter((uid) => uid)) ||
          topicSelected.follower_ids)) ||
      0;

    return (
      <E.Container>
        <E.Title>{`Active participants in Chat`}</E.Title>
        <E.Inner>
          {!userListing ? (
            <E.Scrollable>
              {!!ActiveParticipants &&
                ActiveParticipants.map((userId, index) => {
                  const user = dispatchers.map((d) => d.id === userId && d).filter((d) => d)[0];
                  if (user) {
                    return <ActiveMember user={user} key={`user-${index}`} />;
                  }
                })}
            </E.Scrollable>
          ) : (
            <JLoading />
          )}
        </E.Inner>
      </E.Container>
    );
  }
}
export default compose(withRouter, inject('store'), observer)(ActiveParticipantChat);

class ActiveMember extends Component {
  render() {
    const { user } = this.props;

    return (
      <E.ActiveMember>
        <E.Avatar>
          <E.AvatarImage />
        </E.Avatar>
        <E.Name>{user.username}</E.Name>
      </E.ActiveMember>
    );
  }
}
